// Lithuanian copy for the /landing page.
// Key order mirrors src/copy/landing.en.js, which is page order top to bottom.
// A key deleted here silently falls back to the English string.

export default {
  // ============ HERO  (very top of the page) ============
  "landing.heroTitle": "Nuo pirmų žodžių iki tikrų pokalbių.",
  "landing.heroSubtitle": "Kalbos praktikos programėlė vaikams, kuriems kalbėti sunku. Padeda Timo.",
  "landing.ctaGetStarted": "Pradėti",
  "landing.heroStat1Big": "400+",
  "landing.heroStat1Label": "tėvų jau išbandė",
  "landing.heroStat2Big": "3 režimai",
  "landing.heroStat2Label": "kiekvienam vaikui",
  "landing.heroStat3Label": "sukurta Lietuvoje",

  // ============ RADIO STRIP  (the thin line under the hero) ============
  "landing.radioMention": "Kalbėjome nacionaliniame radijuje.",
  "landing.radioLinkText": "Žinių radijas",

  // ============ THE THREE CARDS ============
  "landing.promiseTitle": "Ekrano laikas, kuris duoda naudos.",
  "landing.promiseBody": "Užuot slinkęs ekraną, vaikas žaidžia su Timo ir mokosi frazių, kurių reikia tikrame gyvenime. Vos 10 min. per dieną.",
  "landing.card1Title": "Bakstelėk ir kalbėk",
  "landing.modeNonverbalDesc": "Vaikas bakstelėja paveikslėlį, o Timo pasako tai balsu. Skaityti nereikia. Puikiai tinka nekalbantiems ir kalbos raidos sutrikimą turintiems vaikams.",
  "landing.card3Title": "Rūpinkis Timo",
  "landing.modeLiveDesc": "Žaidimas, o ne pamoka. Vaikai maitina Timo, guldo jį miegoti ir rūpinasi, kad jam būtų gera. Kad padėtų, jie turi pasakyti, ko jam reikia, o tai praktika, kuri jaučiasi kaip žaidimas.",
  "landing.card2Title": "Kalbėk su Timo",
  "landing.modeChatDesc": "Praktikuokis tikrus pokalbius su Timo: paprašyti pagalbos, prisijungti prie žaidimo. Timo padeda visą kelią.",

  // ============ HOW IT WORKS  (three numbered steps) ============
  "landing.howItWorks": "Kaip tai veikia",
  "landing.howStep1Title": "Bakstelėk paveikslėlį",
  "landing.howStep1Body": "Vaikas paspaudžia tai, ką nori pasakyti, o Timo pasako tai balsu.",
  "landing.howStep2Title": "Praktikuokis su Timo",
  "landing.howStep2Body": "Tos pačios frazės sugrįžta kaip pokalbis su Timo, todėl jas ištarti tampa įprasta dar prieš tikrą gyvenimą.",
  "landing.howStep3Title": "Žaisk ir auk",
  "landing.howStep3Body": "Rūpinimasis Timo paverčia praktiką žaidimu, prie kurio norisi grįžti, ir paprašyti ko nors tampa natūralu.",

  // ============ ORANGE BAND  (full-width, between the steps and the tiles) ============
  "landing.problemTitle": "Žinote, kad jie turi ką pasakyti.",
  "landing.problemBody": "Žodžiai yra viduje. Tik kažkas sutrukdo pačią svarbiausią akimirką: naujas žmogus, triukšminga aplinka, klausimas, ties kuriuo jie sustingsta.",

  // ============ WHAT ELSE IS INSIDE  (three tiles) ============
  "landing.whatWeBuilt": "Kas dar viduje:",
  "landing.featWordTitle": "Dienos žodis",
  "landing.featWordDesc": "Vienas naujas žodis per dieną, laukiantis Timo namuose. Vaikas jį išgirsta, pakartoja ir pasilieka savo žodžių sąraše.",
  "landing.featScriptsTitle": "Frazės, kurias gali pasilikti",
  "landing.featScriptsDesc": "Išsaugok sakinius, kurie veikia: parduotuvei, klasei, gydytojui. Pasitreniruok vieną prieš įeidamas, ir kitą kartą jis jau bus vietoje.",
  "landing.featBreathingTitle": "Nusiraminimo kvėpavimas",
  "landing.featBreathingDesc": "Vedamas kvėpavimo pratimas toms akimirkoms, kai viskas tampa per garsu, kad vaikas galėtų atsikvėpti ir sugrįžti. (BETA)",

  // ============ PARENTS LOVE IT  (the two quotes) ============
  "landing.parentsLoveIt": "Tėvams patinka.",
  "landing.testimonialAlt1Quote": "Tikrai puiki idėja - šią programėlę reikėtų parodyti specialistams mokyklose ir darželiuose.",
  "landing.testimonialAlt1Name": "Katrina S.",
  "landing.testimonialAlt1Author": "Mama, Lietuva",
  "landing.testimonialAlt2Quote": "Nuostabi idėja. Dirbant su žmonėmis, kurie negali kalbėti, ši programėlė tikrai padėtų.",
  "landing.testimonialAlt2Name": "Vida K.",
  "landing.testimonialAlt2Author": "Specialistė, dirbanti su nekalbančiais suaugusiaisiais",

  // ============ ARTICLES RAIL  (the small label above each cover) ============
  "landing.artCat1": "Pirmi žodžiai",
  "landing.artCat2": "Nekalbantys",
  "landing.artCat3": "Autizmas",
  "landing.artCat4": "Nerimas",
  "landing.artCat5": "Kaip išsirinkti",

  // ============ FOUNDER BLOCK ============
  "landing.ourStory": "Kaip mes tai sudarėme",
  "landing.founderName": "Gintaras",
  "landing.founderQuote": "Mano brolis turi Aspergerio sindromą. Pirmąją versiją sukūriau jam, kad akimirkos, kurios kitiems atrodo lengvos, nustotų būti sunkiausia jo dienos dalimi.",
  "landing.founderStory": "Paskui sutikau tėtį, kurio sūnus visai nekalbėjo, ir mes sukūrėme bakstelėk ir kalbėk: vaikas bakstelėja, o programėlė pasako tai balsu. Vėliau vis sutikdavau vaikų, kurie dar tik mokėsi pirmųjų žodžių, tad viską paverčiau žaidimu. Praktika turi jaustis kaip žaidimas, o ne kaip namų darbai.",
  "landing.founderRole": "Timo Helps įkūrėjas",

  // ============ LONG READ  (the collapsed block above the FAQ) ============
  "landing.longTitle": "Kalbos praktikos programėlė, telpanti į įprastą dieną",
  "landing.longP1": "Timo Helps (dar žinoma kaip Time To Talk) yra bendravimo ir kalbos praktikos programėlė vaikams, kuriems kalbėti sunku: vaikams su kalbos raidos sutrikimu, nekalbantiems ir mažai kalbantiems vaikams, autizmo spektro vaikams, vaikams su ADHD ir tiems, kurie namie kalba laisvai, bet sustingsta mokykloje, pas gydytoją ar parduotuvėje. Ji veikia naršyklėje telefone, planšetėje ar kompiuteryje, todėl nieko diegti nereikia ir laukti nereikia.",
  "landing.longP2": "Ji veikia trimis būdais. Bakstelėk ir kalbėk yra paveikslėlių lenta: vaikas bakstelėja tai, ką nori pasakyti, o programėlė ištaria tai balsu, tad balsą jis turi jau pirmą dieną, be skaitymo ir be rašymo. Kalbėk su Timo yra treniruojamasis pokalbis su švelniu personažu, kuris niekada neskubina ir netaiso vaiko kitų akivaizdoje, tad sakiniai, kaip užsisakyti maisto, paprašyti pagalbos ar prisijungti prie žaidimo, pirmiausia repetuojami saugioje vietoje. Rūpinkis Timo visa tai paverčia žaidimu: vaikai jį maitina, guldo miegoti ir rūpinasi, kad jam būtų gera, o kad tai padarytų, jie turi pasakyti, ko jam reikia.",
  "landing.longP3": "Šalia šių trijų yra dienos žodis, vieta frazėms, kurios iš tikrųjų tinka jūsų šeimai, vedamas kvėpavimo pratimas toms akimirkoms, kai pasidaro per garsu, ir apdovanojimai, žymintys pažangą taip, kad praktika netaptų namų darbais. Programėlė veikia lietuvių, anglų, rusų ir ispanų kalbomis.",
  "landing.longP4": "Timo Helps nepakeičia logopedo. Tai praktika tarp užsiėmimų: atsiverčiama 7 val. ryto arba prieš miegą, derinama su specialisto planu. Ji sukurta Lietuvoje įkūrėjo, kurio brolis pats nutildavo prie naujų žmonių, ir šiandien ja naudojasi daugiau nei 400 šeimų. 11,49 EUR per mėnesį, atsisakyti galima bet kada, be reklamų ir nieko apie jūsų vaiką niekam neparduodama.",
  "landing.readMore": "Skaityti daugiau",
  "landing.readLess": "Suskleisti",

  // ============ FAQ  (eleven rows) ============
  "landing.faqSectionTitle": "Dažniausiai klausia",
  "landing.faq1Question": "Kam skirtas Timo?",
  "landing.faq1Answer": "Vaikams maždaug nuo 3 metų: vaikams su kalbos raidos sutrikimu, nekalbantiems ir mažai kalbantiems vaikams, autizmo spektro vaikams ir bet kuriam vaikui, kuriam kalbėti sunku arba kuris sustingsta lemiamu momentu. Daug tėvų naudoja ją ir tada, kai vaikui tiesiog reikia praktikos dėlioti kasdienes frazes.",
  "landing.faq2Question": "Ar vaikas turi mokėti skaityti?",
  "landing.faq2Answer": "Ne. Time To Talk (Timo Helps) naudoja paveikslėlius ir ikonas. Skaityti nebūtina.",
  "landing.faq3Question": "O jeigu mums netiks?",
  "landing.faq3Answer": "Atsisakyti galima bet kada: Profilis, tada Prenumerata. Prieiga lieka iki apmokėto mėnesio pabaigos.",
  "landing.faq4Question": "Ar mūsų duomenys saugūs?",
  "landing.faq4Answer": "Taip. Mes niekada neparduodame jūsų duomenų. Niekada. Privatumas pirmiausia.",
  "landing.faq5Question": "Kiek tai kainuoja?",
  "landing.faq5Answer": "11,49 EUR per mėnesį už viską ir visuose įrenginiuose. Jokių įsipareigojimų, atsisakyti galima bet kada.",
  "landing.faq6Question": "Kokiuose įrenginiuose veikia?",
  "landing.faq6Answer": "Ji veikia naršyklėje, tad tinka telefonas, planšetė ar kompiuteris, ir nieko diegti nereikia. Telefone galima įsidėti ją į pradžios ekraną, ir ji atsidarys kaip bet kuri kita programėlė.",
  "landing.faq7Question": "Kokiomis kalbomis kalba?",
  "landing.faq7Answer": "Lietuvių, anglų, rusų ir ispanų, o BETA versijoje prancūzų, vokiečių ir norvegų. Kalbą pasirenkate pradžioje ir vėliau galite pakeisti nustatymuose.",
  "landing.faq8Question": "Ar tai pakeičia logopedą?",
  "landing.faq8Answer": "Ne, ir nėra tam skirta. Specialistas dirba su tuo, kaip vaikas taria garsus. Timo duoda vietą praktikuotis tarp užsiėmimų, tiek kartų, kiek norisi.",
  "landing.faq9Question": "Kiek laiko tam reikia?",
  "landing.faq9Answer": "Užtenka kelių minučių. Jokių serijų, jokių dienos normų, nieko, kas baustų už praleistą dieną. Dauguma šeimų naudoja trumpais pliūpsniais: prieš parduotuvę, po mokyklos, prieš miegą.",
  "landing.faq10Question": "Ar turiu sėdėti kartu su vaiku?",
  "landing.faq10Answer": "Galite, ir pradžioje tai padeda. Bet ji sukurta taip, kad vaikas galėtų atsiversti ją vienas: viskas yra paveikslėliai, viską galima paspausti, o skaito Timo.",
  "landing.faq11Question": "Kaip pradėti?",
  "landing.faq11Answer": "Atsakote kelis klausimus apie savo vaiką, ir programėlė prisitaiko prie jo lygio bei jūsų nurodytų situacijų. Tai užtrunka kelias minutes, o vėliau viską galima pakeisti.",

  // ============ FINAL CTA AND EVENT CODE  (bottom of the page) ============
  "landing.priceTeaserTitle": "11,49 EUR per mėnesį",
  "landing.priceTeaserBody": "Mažiau nei kava per savaitę. Visi režimai ir visos kalbos įskaičiuotos, atsisakyti galima bet kada.",
  "landing.ctaPlans": "Žiūrėti planus",
  "landing.eventCodeTitle": "Turi kūrėjo ar renginio kodą?",
  "landing.eventCodePlaceholder": "Įvesk kodą",
  "landing.eventCodeCta": "Aktyvuoti kodą",
  "landing.eventCodeNote": "Vienas panaudojimas vienam žmogui. Už piktnaudžiavimą ar dalijimąsi blokuojama.",

  // ============ TOP BAR, MENU AND FOOTER ============
  "landing.signIn": "Prisijungti",
  "landing.ctaTryTimo": "Išbandyk Timo",

  "landing.tryFree": "Gauti Timo",
  "landing.cancelAnytime": "Atšauk bet kada.",
  "landing.feature1Title": "Paliesk, kad kalbėtų",
  "landing.feature1Desc": "Paveikslėliai, kuriuos vaikas liečia. Timo ištaria garsiai.",
  "landing.feature2Title": "Praktiniai pokalbiai",
  "landing.feature2Desc": "Kalbėkis su Timo. Be jokio vertinimo. Bandyk dar kartą.",
  "landing.feature3Title": "Pagalba gyvai",
  "landing.feature3Desc": "Pasiūlymai realiu laiku tikrų pokalbių metu.",
  "landing.quote": "\"Mano sūnus palietė paveikslėlį ir programėlė pasakė tai, ko jis norėjo. Jis pažiūrėjo į mane tarsi klausdamas - ar girdėjai tai. Mes abu verkėme.\"",
  "landing.quoteAuthor": "7-erių metų autistiško vaiko mama, Lietuva",
  "landing.stayUpdated": "Gaukite naujienas",
  "landing.stayUpdatedDesc": "Gaukite patarimus ir istorijas iš šeimų, panašių į jūsų.",
  "landing.subscribe": "Prenumeruoti",
  "landing.subscribing": "Siunčiama...",
  "landing.subscribeSuccess": "✓ Ačiū! Greitai patikrinkite savo el. paštą.",
  "landing.navPricing": "Planai",
  "landing.heroCtaPricing": "Pasirinkti planą",
  "landing.storyIntro": "Pastebėjome kažką",
  "landing.storyPoint1": "Žmonės bendrauja skirtingai.",
  "landing.storyPoint2": "Vieni naudoja žodžius. Vieni - ikonas. Vieni - abu.",
  "landing.storyPoint3": "Dauguma programėlių pasirenka vieną būdą ir laikosi jo.",
  "landing.storyWeBuild": "Mes sudarėme tris veiksenas vienoje programėlėje.",
  "landing.modeNonverbal": "Kalbėk",
  "landing.modeChat": "Pokalbis",
  "landing.modeLive": "Tiesiogiai",
  "landing.storyStats": "187 šeimos jau naudoja",
  "landing.storyUsage": "86% naudoja kasdien",
  "landing.storyBuiltIn": "Sukurta Lietuvoje",
  "landing.storyExpanding": "2026 metais planuojame plėsti darbą po visą ES",
  "landing.storyTryButton": "Gauti Timo →",
  "landing.heroCtaTry": "Gauti Timo",
  "landing.heroCtaGet": "Gauti Time To Talk",
  "landing.stats1Number": "130+",
  "landing.stats1Label": "šeimos jau prenumeruoja",
  "landing.stats2Number": "3 veiksenos",
  "landing.stats2Label": "kiekvienam vaikui",
  "landing.stats3Number": "🇱🇹",
  "landing.stats3Label": "sukurta Lietuvoje",
  "landing.modesTitle": "Viena programėlė. Trys pagalbos būdai.",
  "landing.modesSubtitle": "Kai kurie vaikai negali kalbėti. Kai kurie bijo. Kai kuriems reikia pagalbos šioje akimirkoje.",
  "landing.modeNonverbalTitle": "„Kalbėk“ režimas",
  "landing.modeChatTitle": "Pokalbio veiksena",
  "landing.modeLiveTitle": "Pasirūpink Timo",
  "landing.modeLiveBadge": "NAUJIENA",
  "landing.scrollHint": "slinkti",
  "landing.featAwardsTitle": "Apdovanojimai ir pažanga",
  "landing.featAwardsDesc": "Trofėjai švenčia kiekvieną žingsnį, todėl bendravimo praktika tampa žaidimu, o ne namų darbais.",
  "landing.devBypassLogin": "Kūrėjo prisijungimo apėjimas",
  "landing.devBypassHome": "Kūrėjo apėjimas į programą",
  "landing.testimonialQuote": "\"Jis jį naudojo pirmą dieną. Pats prašė vandens. Pirmą kartą iš viso.\"",
  "landing.testimonialAuthor": "Tėvas iš Vilniaus",
  "landing.founderTitle": "Sveiki, aš Gintaras",
  "landing.founderHook": "Mačiau, kaip mano brolis nutyla kiekvieną kartą, kai su juo kalba naujas žmogus. Mokytojai. Kiti vaikai. Žmonės aplinkui.",
  "landing.founderProblemLabel": "Problema",
  "landing.founderProblemText": "Namuose jis kalbėjo normaliai. Bet kitur? Viskas dingdavo. Todėl nusprendžiau sukurti įrankį, padedantį žmonėms kalbėti.",
  "landing.founderSearchLabel": "Ką radau",
  "landing.founderSearchText": "Ieškojau programėlių, kurios padėtų. Viskas, ką radau, buvo per sudėtinga ir nelabai naudinga.",
  "landing.founderBuildLabel": "Ką sukūriau būdamas 16-os",
  "landing.founderBuildPoint1": "Tada sutikau tėvus, kurių vaikas tiesiogine prasme negalėjo pasakyti \"aš alkanas\" ar palaikyti ryšio su artimaisiais.",
  "landing.founderBuildPoint2": "Dvi skirtingos problemos. Nulis gerų sprendimų. Todėl 16-os pradėjau kurti Time To Talk.",
  "landing.founderBuildPoint3": "Palieti ikoną ir programėlė kalba. Praktikuoji pokalbius be spaudimo. Gauni pagalbą realiu laiku, kai užstringi.",
  "landing.founderForWho": "Visiems, kuriems reikia pagalbos bendraujant.",
  "landing.founderLine1": "Mačiau, kaip mano brolis nutyla kiekvieną kartą, kai su juo kalba naujas žmogus.",
  "landing.founderLine2": "Mokytojai. Kiti vaikai. Žmonės už namų ribų.",
  "landing.founderLine3": "Namuose jis galėjo kalbėti normaliai. Bet kitur - tarsi viskas dingdavo.",
  "landing.founderLine4": "Ieškojau programėlių, kurios padėtų. Viskas, ką radau, buvo per sudėtinga ir nelabai naudinga.",
  "landing.founderLine5": "Tada sutikau tėvus, kurių vaikas tiesiogine prasme negalėjo pasakyti \"aš alkanas\" ar palaikyti ryšio su artimaisiais.",
  "landing.founderLine6": "Dvi skirtingos problemos. Nulis gerų sprendimų. Todėl 16-os pradėjau kurti Time To Talk: palieti ikoną ir programėlė kalba, praktikuoji pokalbius be spaudimo, gauni pagalbą realiu laiku, kai užstringi. Visiems, kuriems reikia pagalbos bendraujant.",
  "landing.founderAttribution": "Gintaras, Time To Talk įkūrėjas",
  "landing.finalCtaTitle": "Jie turi ką pasakyti.",
  "landing.finalCtaSubtitle": "Padėkime jiems tai pasakyti.",
  "landing.finalCtaButton": "Gauti Time To Talk",
  "landing.faqDropdownTitle": "DUK",
  "landing.pricingDropdownTitle": "Kainų lentelė",
  "landing.priceIncreaseBanner": "Steigėjo kaina baigiasi po {timeLeft}",
  "landing.pricingTitle": "Kainos.",
  "landing.ctaSeePlans": "Rinktis planą",
  "landing.stickyCta": "Įsigyti Time To Talk",
  "landing.howTitle": "Pradėkite padėti jau šiandien",
  "landing.priceTeaserCta": "Žiūrėti visas kainas",
};
